"use client";

import * as React from "react";
import CopyIcon from "../icons/copyIcon";
import ArthaLink20x17Icon from "../icons/ArthaLink20x17Icon";

interface ShareLinkRowProps {
  link: string;
  onCopy?: () => void;
  className?: string;
}

export function ShareLinkRow({ link, onCopy, className }: ShareLinkRowProps) {
  return (
    <div className={["flex items-center justify-between rounded-lg border border-black bg-white px-3 py-1", className].filter(Boolean).join(" ")}>
      <div className="flex items-center gap-2 text-sm text-[#344054] min-w-0">
        <div className="flex h-6 w-6 items-center justify-center rounded-md">
          <ArthaLink20x17Icon />
        </div>
        <span className="truncate">{link}</span>
      </div>
      {onCopy && (
        <button
          type="button"
          className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md text-[#344054]"
          onClick={onCopy}
          aria-label="Copy link"
        >
          <CopyIcon />
        </button>
      )}
    </div>
  );
}
